import { Component, inject, Input } from '@angular/core';
import { NoticeMedia } from '../notice.model';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NoticeService } from '../../../services/notice.service';
import { UserService } from '../../../services/user.service';
import { MessagingService } from '../../../components/messaging/messaging.service';

@Component({
  selector: 'notice-media-document-item',
  imports: [MatIconModule, NgClass],
  template: `
    <div
      class="grid place-items-center rounded-t w-100 h-80 bg-neut-var-90"
      [ngClass]="{ 'hover:cursor-pointer': !adminView }"
      (click)="!adminView && openOrDownloadFile()">
      @if (extensionsWithIcons.includes(document.extension)) {
        <mat-icon class="size-[50px]! text-[50px]!" [svgIcon]="document.extension + '_icon'" />
      } @else {
        <div class="max-w-full truncate">{{ document.extension }}</div>
      }
    </div>
  `
})
export class NoticeImageDocumentItemComponent {
  @Input() adminView = false;
  @Input() document: NoticeMedia;

  #noticeService = inject(NoticeService);
  #userService = inject(UserService);
  #message = inject(MessagingService);

  extensionsWithIcons = ['txt', 'docx', 'pdf', 'xlsx'];
  extensionToOpen = ['png', 'jpeg', 'jpg', 'pdf'];

  openOrDownloadFile() {
    const { id, fullName, extension } = this.document;
    this.#noticeService.getNoticeMediaUrl(id).subscribe({
      next: (documentUrl: string) => {
        if (documentUrl) {
          if (this.extensionToOpen.includes(extension)) {
            window.open(documentUrl, '_blank');
          } else {
            this.#userService.getDocumentUsingUrl(documentUrl).subscribe((response) => {
              const a = window.document.createElement('a');
              const url = window.URL.createObjectURL(response);
              a.href = url;
              a.download = fullName;
              window.document.body.appendChild(a);
              a.click();
              window.document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            });
          }
        } else {
          this.#message.error(`There was an error loading ${fullName}.`);
        }
      },
      error: () => this.#message.error(`There was an error loading ${fullName}.`)
    });
  }
}
